/* tslint:disable:jsx-no-multiline-js */
import React from 'react';
import PropTypes from 'prop-types';
import PopupDatePicker from 'rmc-date-picker/lib/Popup';
import RCDatePicker from 'rmc-date-picker/lib/DatePicker';
import { formatFn } from './utils';
import { getComponentLocale } from '../_util/getLocale';
export default class DatePicker extends React.Component {
    constructor() {
        super(...arguments);
        this.setScrollValue = (v) => {
            this.scrollValue = v;
        };
        this.onOk = (v) => {
            if (this.scrollValue !== undefined) {
                v = this.scrollValue;
            }
            if (this.props.onChange) {
                this.props.onChange(v);
            }
            if (this.props.onOk) {
                this.props.onOk(v);
            }
        };
        this.fixOnOk = (picker) => {
            if (picker) {
                picker.onOk = this.onOk;
            }
        };
    }
    render() {
        const { props, context } = this;
        const { children, value, popupPrefixCls } = props;
        const locale = getComponentLocale(props, context, 'DatePicker', () => require('./locale/zh_CN'));
        const { okText, dismissText, extra, DatePickerLocale } = locale;
        const dataPicker = (<RCDatePicker minuteStep={props.minuteStep} locale={DatePickerLocale} minDate={props.minDate} maxDate={props.maxDate} mode={props.mode} pickerPrefixCls={props.pickerPrefixCls} prefixCls={props.prefixCls} defaultDate={value} use12Hours={props.use12Hours} onValueChange={props.onValueChange} onScrollChange={this.setScrollValue}/>);
        return (<PopupDatePicker datePicker={dataPicker} WrapComponent="div" transitionName="am-slide-up" maskTransitionName="am-fade" {...props} prefixCls={popupPrefixCls} date={value} dismissText={this.props.dismissText || dismissText} okText={this.props.okText || okText} ref={this.fixOnOk}>
        {children && React.cloneElement(children, { extra: value ? formatFn(this, value) : (this.props.extra || extra) })}
      </PopupDatePicker>);
    }
}
DatePicker.defaultProps = {
    mode: 'datetime',
    prefixCls: 'am-picker',
    pickerPrefixCls: 'am-picker-col',
    popupPrefixCls: 'am-picker-popup',
    minuteStep: 1,
    use12Hours: false,
};
DatePicker.contextTypes = {
    antLocale: PropTypes.object,
};



// WEBPACK FOOTER //
// ./components/date-picker/index.tsx